import moment from "moment";
import { createCrudActions } from "../utils/crudGenerator";
import { axios } from "../connection/ConnectionHandler";
import { SHOW_NOTIFICATION } from "../constants";

const formatInvoices = (data) => {
	if (!data) {
		return [];
	}
	const formatItem = (item) => ({
		...item,
		label: `${item.name}`,
		value: item._id,
		date: item.date && moment(item.date),
	});

	if (Array.isArray(data)) {
		return data.map(formatItem);
	}
	return formatItem(data);
};

export const {
	fetch: fetchInvoices,
	create: createInvoice,
	update: updateInvoice,
	delete: deleteInvoices,
} = createCrudActions("INVOICE", "Factura", formatInvoices);

export const sendInvoicePDF = (invoiceNumber, pdf, email) => async (dispatch) => {
	try {
		const response = await axios.post("Invoice/send-pdf", { invoiceNumber, pdf, email });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: { show: true, status: "success", message: "Factura enviada por email" },
		});
		return response.status;
	} catch (err) {
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: { show: true, status: "error", message: "No se pudo enviar la factura" },
		});
		return err;
	}
};
